import axios from 'axios';

const API_URL = `${process.env.REACT_APP_API_URL || 'http://localhost:5000'}/api`;

export const register = (data) => axios.post(`${API_URL}/auth/register`, data);
export const login = (data) => axios.post(`${API_URL}/auth/login`, data);
export const getBanners = () => axios.get(`${API_URL}/banners`);
export const getServices = () => axios.get(`${API_URL}/services`);

// Job management (admin)
export const getJobs = (token) => axios.get(`${API_URL}/jobs`, token ? { headers: { Authorization: `Bearer ${token}` } } : undefined);
export const addJob = (data, token) => axios.post(`${API_URL}/jobs`, data, { headers: { Authorization: `Bearer ${token}` } });
export const deleteJob = (id, token) => axios.delete(`${API_URL}/jobs/${id}`, { headers: { Authorization: `Bearer ${token}` } });
